const APP_PREFIX = process.env.REACT_APP_PREFIX

export const ROOT_PATH = "/";
export const APP_PATH = APP_PREFIX;
export const LOGIN_PATH = `${APP_PREFIX}/login`;
export const PROGRAM_ROUTE = `${APP_PREFIX}/program`;
export const PROFILE_ROUTE =`${APP_PREFIX}/profile`;
export const HOME_ROUTE = `${APP_PREFIX}/home`;
export const PEOPLE_ROUTE = `${APP_PREFIX}/people`;
export const SAFETY_ROUTE = `${APP_PREFIX}/safety`;
export const PEOPLE_REMOVED_ROUTE = `${APP_PREFIX}/people/removed`;
export const PEOPLE_TEAMS_ROUTE = `${APP_PREFIX}/teams`;
export const PEOPLE_GUEST_ROUTE = `${APP_PREFIX}/guest`;
export const CREATE_GUEST_PROFILE = `${APP_PREFIX}/guest/create`;
export const GUEST_DETAILS_ROUTE = `${APP_PREFIX}/guest/:guestId`;

export const POLICY_ROUTE = `${APP_PREFIX}/policy`;
export const PAYMENT_ROUTE = `${APP_PREFIX}/payment`;
export const LOYALTY_ROUTE = `${APP_PREFIX}/loyalty`;
export const TRAVEL_CREDITS_ROUTE = `${APP_PREFIX}/travelcredits`;
export const AVAILABLE_CREDITS_ROUTE = `${APP_PREFIX}/travelcredits/available`;
export const USED_CREDITS_ROUTE = `${APP_PREFIX}/travelcredits/used`;
export const EXPIRED_CREDITS_ROUTE = `${APP_PREFIX}/travelcredits/expired`;
export const DISCOUNTS_ROUTE = `${APP_PREFIX}/discounts`;
export const PROMOTIONS_ROUTE = `${APP_PREFIX}/promotions`;
export const PROMOTIONS_PARTNER_ROUTE = `${APP_PREFIX}/promotions/partner`;

export const AADVANTAGE_PASS_ROUTE = `${APP_PREFIX}/aadvantagepass`;

export const REPORTS_ROUTE = `${APP_PREFIX}/reports`;
export const REPORTS_BOOKING_ROUTE = `${APP_PREFIX}/reports/bookings`;
export const REPORTS_MILEAGE_ROUTE = `${APP_PREFIX}/reports/mileage`;
export const REPORTS_RECEIPTS_ROUTE = `${APP_PREFIX}/reports/receipts`;
export const REPORTS_HOTEL_BOOKING_ROUTE = `${APP_PREFIX}/reports/hotel-bookings`;
export const REPORTS_SPEND_ROUTE = `${APP_PREFIX}/reports/spend`;
export const REPORTS_COMPLIANCE_ROUTE = `${APP_PREFIX}/reports/policy-compliance`;
export const REPORTS_BOOKING_SUMMARY = `${APP_PREFIX}/reports/summary`;
export const REPORTS_FLIGHT_SEGMENTS_ROUTE = `${APP_PREFIX}/reports/flight-segments`;
export const REPORTS_TICKETS_ROUTE = `${APP_PREFIX}/reports/tickets`;
export const REPORTS_COUPONS_ROUTE = `${APP_PREFIX}/reports/coupons`;

export const HELP_ROUTE = "";
export const BACK_TO_AA = "";
export const LEAVE_COMPANY = `${APP_PREFIX}/leave-company`;
export const REVOKED_DOMAIN_ROUTE = `${APP_PREFIX}/domain-verification-failure`;
export const SUCCESS_DOMAIN_ROUTE = `${APP_PREFIX}/domain-verification-success`;

//admin navigation routes
export const ADMIN_PEOPLE_ROUTE = `${APP_PREFIX}/admin/people`;
export const ADMIN_COMPANIES_ROUTE = `${APP_PREFIX}/admin/companies`;
export const ADMIN_REPORTS_ROUTE = `${APP_PREFIX}/admin/reports`;
export const ADMIN_SETTINGS_ROUTE = `${APP_PREFIX}/admin/settings`;
export const ADMIN_LOYALTY_ROUTE = `${APP_PREFIX}/admin/loyalty`;
export const ADMIN_LOGIN_ROUTE = `${APP_PREFIX}/adminlogin`;

// admin tabs
export const ADMIN_COMPANIES_REMOVED_TAB_ROUTE = `${APP_PREFIX}/admin/companies/removed`;
export const ADMIN_COMPANIES_PENDING_TAB_ROUTE = `${APP_PREFIX}/admin/companies/pending`;
export const ADMIN_COMPANY_DETAILS_ROUTE = `${APP_PREFIX}/admin/companies/:companyEntityId`;
export const ADMIN_SETTINGS_MAINTENANCE_ROUTE = `${APP_PREFIX}/admin/settings/maintenance`;
export const ADMIN_LOYALTY_ALLOTMENTS_ROUTE = `${APP_PREFIX}/admin/loyalty/allotments`;
export const ADMIN_LOYALTY_NOTIFICATIONS_ROUTE = `${APP_PREFIX}/admin/loyalty/notifications`; 
export const FAILED_LOYALTY_ROUTE =`${APP_PREFIX}/admin/loyalty/allotments/failed`;
export const COMPLETED_LOYALTY_ROUTE =`${APP_PREFIX}/admin/loyalty/allotments/completed`;
export const PENDING_LOYALTY_ROUTE =`${APP_PREFIX}/admin/loyalty/allotments/pending`;
export const ADMIN_PEOPLE_REMOVED_TAB_ROUTE = `${APP_PREFIX}/admin/people/removed`;
export const ADMIN_TRAVELER_DETAILS_ROUTE = `${APP_PREFIX}/admin/people/:travelerId`;
export const ADMIN_LOYALTY_REQUESTS_ROUTE = `${APP_PREFIX}/admin/loyalty/requests`;
export const FAILED_REQUESTS_LOYALTY_ROUTE =`${APP_PREFIX}/admin/loyalty/requests/failed`;
export const COMPLETED_REQUESTS_LOYALTY_ROUTE =`${APP_PREFIX}/admin/loyalty/requests/completed`;
export const PENDING_REQUESTS_LOYALTY_ROUTE =`${APP_PREFIX}/admin/loyalty/requests/pending`;


// teams
export const TEAM_DETAILS_ROUTE = `${APP_PREFIX}/teams/:teamId`;
export const TEAM_DETAILS_BOOKINGS_ROUTE = `${APP_PREFIX}/teams/:teamId/bookings`;
export const TEAM_DETAILS_SETTINGS_ROUTE = `${APP_PREFIX}/teams/:teamId/settings`;

//traveler
export const TRAVELER_DETAILS_ROUTE = `${APP_PREFIX}/people/:travelerId`;
export const TRAVELER_DETAILS_JOIN_ROUTE = `${APP_PREFIX}/people/:travelerId/join`;

//settings
export const SETTINGS_ROUTE = `${APP_PREFIX}/settings`;
export const SETTINGS_EMAILDOMAINS_ROUTE = `${APP_PREFIX}/settings/email-domains`;
export const SETTINGS_INTEGRATIONS_ROUTE = `${APP_PREFIX}/settings/integrations`;
export const SETTINGS_NOTIFICATIONS_ROUTE = `${APP_PREFIX}/settings/notifications`;
export const SETTINGS_BOOKINGFIELDS_ROUTE = `${APP_PREFIX}/settings/booking-fields`;
export const AIRLINEPROGRAMS_ROUTE = `${APP_PREFIX}/join`;
export const AIRLINEPROGRAMS_DELTAAIRLINES_ROUTE = `${APP_PREFIX}/join/delta-airlines`;
export const AIRLINEPROGRAMS_DELTAAIRLINESPROGRAM_ROUTE = `${APP_PREFIX}/join/delta-airlines-program`;
export const AIRLINEPROGRAMS_AMERICANAIRLINES_ROUTE = `${APP_PREFIX}/join/american-airlines`;
export const AIRLINEPROGRAMS_ALASKAAIRLINES_ROUTE = `${APP_PREFIX}/join/alaska-airlines`;
export const AIRLINEPROGRAMS_UNITEDAIRLINES_ROUTE = `${APP_PREFIX}/join/united-airlines`;

export const NOT_FOUND_ROUTE = "/404";
export const ERROR_PAGE_ROUTE = "/500";
export const UNAUTHORIZED_PAGE_ROUTE = "/403";

export const ESCALATION_FORM_ROUTE = `${APP_PREFIX}/escalation-form`;
export const ESCALATION_MESSAGE_ROUTE = `${APP_PREFIX}/escalation-message`;
export const MAINTENANCE = `${APP_PREFIX}/maintenance`;
export const COMPANY_DELETED_ROUTE = `${APP_PREFIX}/company-deleted`;

// policy
export const EDIT_POLICY_ROUTE = `${APP_PREFIX}/policy/edit/:policyId`;
export const EDIT_SPECIFIC_POLICY_ROUTE = `${APP_PREFIX}/policy/edit/:policyId/edit-specific`;
export const ADD_SPECIFIC_POLICY_ROUTE = `${APP_PREFIX}/policy/edit/:policyId/add-specific`;
export const SETTINGS_FAREACCESS_ROUTE = `${APP_PREFIX}/settings/fare-access`;